class mouseActions {

	constructor(args)
		{
			this.$Any = window.$Any || {};
			this.$ = window.$ || {};
			this.id = args['user_id'];
			this.currentUserData = JSON.parse(localStorage.getItem("userData"));
			this.whiteboardValues = this.currentUserData.whiteboardValues;
			this.onDemand = window['onDemand'];
			this.sep = '~@$';
			this.guestUser = window['guestUser'];
			this.tablete = window['tablete'];
			this.android = window['android'];
			this.hostVirtual = false;
			
			if ( args['host_virtual'] )
				{
					this.hostVirtual = true;
					console.log('load host virtual');
				}
			
			if ( !this.guestUser && !this.hostVirtual && !this.onDemand )
				{
					this.canvas = this.$Any('#sessionCanvas'+this.id)[0];
					this.editDot = this.$Any('#editDot'+this.id)[0];
					this.canvasWrap = this.$Any('#canvasWrap'+this.id)[0];
					this.canvasWrap.style.cursor = 'crosshair';

					this.canvasLine = this.$Any('#canvasLine'+this.id)[0];
					this.canvasSquare = this.$Any('#canvasSquare'+this.id)[0];
					this.canvasCircle = this.$Any('#canvasCircle'+this.id)[0];
					this.canvasFreeHand = this.$Any('#canvasFreeHand'+this.id)[0];
					this.canvasJoined = this.$Any('#canvasJoined'+this.id)[0];
					this.canvasGridSwitch = this.$Any('#canvasGridSwitch'+this.id)[0];
					this.canvasEraser = this.$Any('#canvasEraser'+this.id)[0];
					this.canvasScreenshot = this.$Any('#canvasScreenshot'+this.id)[0];
					this.canvasClear = this.$Any('#canvasClear'+this.id)[0];
					this.canvasClearLines = this.$Any('#canvasClearLines'+this.id)[0];
					this.canvasLadder = this.$Any('#canvasLadder'+this.id)[0];
					this.canvasCone = this.$Any('#canvasCone'+this.id)[0];
					this.canvasSingleCone = this.$Any('#canvasSingleCone'+this.id)[0];
					this.canvasBox = this.$Any('#canvasBox'+this.id)[0];
					this.canvasHurdle = this.$Any('#canvasHurdle'+this.id)[0];
					this.canvasBag = this.$Any('#canvasBag'+this.id)[0];
					this.canvasBall = this.$Any('#canvasBall'+this.id)[0];
					this.canvasAngle = this.$Any('#canvasAngle'+this.id)[0];
					
					if ( this.currentUserData.isMarketplaceChannel == 0  )
						{
							this.canvasGridSwitch.addEventListener('click', this.gridSwitch.bind(this), false);
							this.canvasLine.addEventListener('click', this.paletteShapeClick.bind(this), false);
							this.canvasSquare.addEventListener('click', this.paletteShapeClick.bind(this), false);
							this.canvasCircle.addEventListener('click', this.paletteShapeClick.bind(this), false);
							this.canvasFreeHand.addEventListener('click', this.paletteShapeClick.bind(this), false);
							this.canvasJoined.addEventListener('click', this.paletteShapeClick.bind(this), false);
							this.canvasEraser.addEventListener('click', this.paletteShapeClick.bind(this), false);
							this.canvasAngle.addEventListener('click', this.paletteShapeClick.bind(this), false);
							this.canvasClear.addEventListener('click', this.paletteClearClick.bind(this), false);
							this.canvasClearLines.addEventListener('click', this.paletteClearClick.bind(this), false);
							this.canvasLadder.addEventListener('click', this.paletteEquipmentClick.bind(this), false);
							this.canvasCone.addEventListener('click', this.paletteEquipmentClick.bind(this), false);
							//this.canvasSingleCone.addEventListener('click', canvasSingleConeClick, false);
							this.canvasBox.addEventListener('click', this.paletteEquipmentClick.bind(this), false);
							this.canvasHurdle.addEventListener('click', this.paletteEquipmentClick.bind(this), false);
							this.canvasBag.addEventListener('click', this.paletteEquipmentClick.bind(this), false);
							this.canvasBall.addEventListener('click', this.paletteEquipmentClick.bind(this), false);
							this.canvasScreenshot.addEventListener('click', this.canvasScreenshotClick.bind(this), false);
						}
					
				}
			else if ( this.guestUser || this.hostVirtual || this.onDemand )
				{
					this.canvas = document.getElementById('sessionCanvas');
					this.canvasWrap = document.getElementById('canvasWrap');
					this.editDot = document.getElementById('editDot');
				}
			
			this.ctx = this.canvas.getContext("2d");
			
			this.canvas.removeEventListener("pointerdown", this.mouseDownf.bind(this));
			this.canvas.removeEventListener("pointermove", this.mouseMove.bind(this));
			this.canvas.removeEventListener("pointerup", this.mouseUp.bind(this));
			this.canvas.removeEventListener("pointerout", this.mouseOut.bind(this)); 
			this.canvas.removeEventListener("mousedown", this.mouseDownf.bind(this));
			this.canvas.removeEventListener("mousemove", this.mouseMove.bind(this));
			this.canvas.removeEventListener("mouseup", this.mouseUp.bind(this));
			this.canvas.removeEventListener("mouseout", this.mouseOut.bind(this));
			
			if ( this.editDot )
				{
					this.editDot.removeEventListener("pointerdown", this.editDown.bind(this));
					//this.editDot.removeEventListener("pointerup", stopEdit);
					this.editDot.removeEventListener("mousedown", this.editDown.bind(this));
					//this.editDot.removeEventListener("mouseup", stopEdit);
				}
			
			//add event listner to canvas
			if ( !this.guestUser && !this.onDemand && !this.hostVirtual )
				{
					if ( this.tablete || this.android )
						{
							this.canvas.style.touchAction = 'none';
							this.canvas.addEventListener('touchstart', this.mouseDownf.bind(this), false);
							this.editDot.addEventListener('touchstart', this.editDown.bind(this), false);
							//this.editDot.addEventListener('touchend', stopEdit, false);
							this.canvas.addEventListener('touchmove', this.mouseMove.bind(this), false);
							this.canvas.addEventListener('touchend', this.mouseUp.bind(this), false);
							this.canvas.addEventListener ("touchcancel", this.mouseOut.bind(this), false);
						}
					else
						{
							this.canvas.addEventListener('mousedown', this.mouseDownf.bind(this), false);
							this.editDot.addEventListener('mousedown', this.editDown.bind(this), false);
							//this.editDot.addEventListener('mouseup', stopEdit, false);
							this.canvas.addEventListener('mousemove', this.mouseMove.bind(this), false);
							this.canvas.addEventListener('mouseup', this.mouseUp.bind(this), false);
							this.canvas.addEventListener ("mouseout", this.mouseOut.bind(this), false);
						}
				}
			
			this.canvasDiffW = 1;
			this.canvasDiffH = 1;
			this.pauseClick = false;
			this.pauseDrawing = false;
			this.mouseDown = false;
			this.chosenShape = 0; // 0 = straight line, 1 = rectangle, 2 = circle, 3 = free hand, 4 = joined lines, 5 = eraser, 6 = ladder, 7 = cone, 8 = box, 9 = hurdle, 10 = punching bag, 11 = yoga ball, 12 = angle tool, 14 = Box Horizontal, 15 = reaction drill
			this.stPoint = {};
			this.endPoint = {};
			this.rect = {};
			this.joinedLines = [];
			this.currentFreeLine = [];
			this.angleDots = [];
			this.x1 = 0;
			this.y1 = 0; // start points
			this.prevX = 0;
			this.currX = 0;
			this.prevY = 0;
			this.currY = 0; // free hand drawing coordinates
			this.strokeColor = this.whiteboardValues.defaultColor;
			this.linesWidth = this.whiteboardValues['lineW'];
			this.movingItem = false;
			this.eraserLink = 'url(./images/eraser.cur)';
			this.chosenEditEl = false;
			this.startPoint = 0;
			this.circleObj = {};
			this.ctx2 = false;
			if ( this.guestUser )
				{
					this.bagToolTip = document.getElementById('bagToolTip'+this.id);
				}
			else
				{
					this.bagToolTip = this.$Any('#bagToolTip'+this.id)[0];
				}
			window.clearCanvasLines = this.paletteClearClick;
		}
		
	paletteShapeClick(e) {
		var clickedElement = e.target;
		this.chooseShape(clickedElement.getAttribute('data-shape-id'));
		this.deleteBackground();
		clickedElement.setAttribute('style', 'background-color:#6D118C!important;');
	}
	
	paletteEquipmentClick(e) {
		var clickedElement = e.target;
		var equipmentType = clickedElement.getAttribute('data-shape-id');
		var equipmentArray = [];
		
		console.log('paletteEquipmentClick activityBuilderObject', this.whiteboard.activityBuilderContent.activityBuilderObject);
		
		
		
		
		
		/* if ( equipmentType == 6 ) { equipmentArray = this.whiteboard.ladderDraw.addLadder(this.id); }
		if ( equipmentType == 7 ) { equipmentArray = this.whiteboard.coneDraw.addCones(window['alreadyDrawnCone'+this.id], window['alreadyDrawnConeDiagonal'+this.id], this.whiteboard.canvasLines, window['coneAttributes'+this.id], window['coneAttributesDiag'+this.id], this.canvas.width, this.canvas.height, this.whiteboard.imgList['7'], this.id, this.whiteboard.newConesSize); }
		if ( equipmentType == 8 ) { equipmentArray.push({'t': 'box', 'startX': this.canvas.width-this.whiteboard.imgList['8'][0]/3, 'startY': this.canvas.height-this.whiteboard.imgList['8'][1]/3, 'w': this.whiteboard.imgList['8'][0]/3, 'h': this.whiteboard.imgList['8'][1]/3}); }
		if ( equipmentType == 9 ) { equipmentArray.push({'t': 'hurdle', 'startX': this.canvas.width-this.whiteboard.imgList['9'][0]/3, 'startY': this.canvas.height-this.whiteboard.imgList['9'][1]/3, 'w': this.whiteboard.imgList['9'][0]/3, 'h': this.whiteboard.imgList['9'][1]/3}); }
		if ( equipmentType == 10 ) { equipmentArray = this.whiteboard.bagDraw.addBag(window['alreadyDrawnBag'+this.id], this.whiteboard.canvasLines, window['bagAttributes'+this.id], this.canvas.width, this.canvas.height, this.whiteboard.imgList['10'], this.this.id); }
		if ( equipmentType == 11 ) { equipmentArray.push({'t': 'ball', 'startX': this.canvas.width-this.whiteboard.imgList['11'][0]/3, 'startY': this.canvas.height-this.whiteboard.imgList['11'][1]/3, 'w': this.whiteboard.imgList['11'][0]/3, 'h': this.whiteboard.imgList['11'][1]/3}); } */
		
		this.paletteClearClick();
		this.whiteboard.canvasLines = equipmentArray;
		
		this.chooseShape(equipmentType);
		this.whiteboard.drawLines();
		this.whiteboard.sendDrawRTM(window['allPartDetails'][this.id]['email']);
		
		//window['getZeroTimer'+this.id]();
		
		this.deleteBackground();
		clickedElement.setAttribute('style', 'background-color:#6D118C!important;');
	}
	
	paletteClearClick = (e) => {
		if ( this.$('#bagToolTip'+this.id) && this.$('#bagToolTip'+this.id).html() == 'Converting video to picture...' && !this.$('#bagToolTip'+this.id).hasClass('d-none') ) { return false; }
		
		if ( this.whiteboard.ctx ) { this.whiteboard.ctx.clearRect(0, 0, 1280, 720); }
		this.whiteboard.canvasLines = [];
		this.joinedLines = [];
		this.currentFreeLine = [];
		this.stPoint = false;
		this.$('#repCount'+this.id).html(0);
		this.whiteboard.drawLines();
		
		if ( !this.guestUser && !this.hostVirtual && !this.onDemand )
			{
				if ( this.whiteboard.gridOn ) { this.$('#canvasGridSwitch'+this.id).trigger('click'); }
				if ( window['highlightActive'] ) { window['highlightChanges'](); }
				this.whiteboard.sendDrawRTM(window['allPartDetails'][this.id]['email']);
			}
	}
	
	getMousePosition(e) {
		var mousePosition = {
			'x': 0, 
			'y': 0
		};
		let countDiff = true;
		this.canvasDiffW = this.$(this.canvas).width() / 1280;
		this.canvasDiffH = this.$(this.canvas).height() / 720;
		
		var hostDiff = this.$('#sessionCanvas' + this.id).width() / this.canvas.width;
		var hostDiffH = this.$('#sessionCanvas' + this.id).height() / this.canvas.height;
		if ( this.tablete || this.android )
			{
				if (e)
					{
						mousePosition['x'] = e.changedTouches[0].clientX - this.$('#sessionCanvas' + this.id).offset().left;
						mousePosition['y'] = e.changedTouches[0].clientY - this.$('#sessionCanvas' + this.id).offset().top;
					}
				
			}
		else 
			{
				if (e)
					{
						
						if ( this.whiteboard.electron )
							{
								mousePosition['x'] = e.offsetX;
								mousePosition['y'] = e.offsetY;
							}
						else 
							{
								countDiff = false;
								mousePosition['x'] = e.offsetX;
								mousePosition['y'] = e.offsetY;
							}							
					}
				
			} 
	
		mousePosition['x'] = mousePosition['x'] / hostDiff;
		mousePosition['y'] = mousePosition['y'] / hostDiffH;
			

		return mousePosition;
	}
	
	mouseDownf(e) {
		console.log('mouseDownf this', this);
		console.log('mouseDownf e', e);
		if ( window.virtualInProgress )
			{
				var checkFlutterVirtual = window.virtualInProgress();
				if ( checkFlutterVirtual ) { return false; }
			}
		if ( e ) { e.preventDefault(); }
		if ( !this.whiteboard.viewCaptured && this.whiteboard.hasEquipment && !this.whiteboard.measuringProcess && this.whiteboard.hasConeScript ) { return false; }
		if ( this.whiteboard.roomSetupStarted ) { return false; }
		if ( this.pauseClick || this.pauseDrawing ) { return true; }
		
		if ( !this.guestUser && this.onDemand == undefined )
			{
				window.showFMSPalette(this.id);
				this.$('.screenshot-dropdown').addClass('d-none');
				this.$('.canvasNotePopup').css({'display': 'none', 'opacity': '0'});
				this.$('.canvasNotePopup').find('textarea').html('');
				this.canvas.style.opacity = 1;
				//resetImageCanvas();
			}
		
		var mousePosition = this.getMousePosition(e);
		var mouseX = mousePosition['x'];		
		var mouseY = mousePosition['y'];
		var stopLoop = false;
		var shapeNum = false;
		var shapeName = false;
		this.mouseDown = true;
		
		if ( this.chosenShape == 4 && this.stPoint )
			{
				this.endPoint = this.createPoint(mouseX, mouseY); //get end point
				this.whiteboard.canvasLines.push(this.lineP(this.stPoint, this.endPoint)); //store line points for next draw
				this.joinedLines.push(this.lineP(this.stPoint, this.endPoint));
				this.whiteboard.canvasLines[this.whiteboard.canvasLines.length-1]['cl'] = this.strokeColor;
				this.whiteboard.canvasLines[this.whiteboard.canvasLines.length-1]['lineW'] = this.linesWidth;
				this.whiteboard.canvasLines[this.whiteboard.canvasLines.length-1]['t'] = 'j';
			}
		
		var mainthis = this;
		this.whiteboard.canvasLines.forEach(function(item, index) {
			if ( !stopLoop && mainthis.joinedLines.length == 0 && mainthis.angleDots.length == 0 )
				{
					var foundElement = mainthis.distFromElement(e, item, index, mouseX, mouseY);
					if ( foundElement[0] ) { mainthis.movingItem = index + 1; shapeNum = foundElement[1]; shapeName = foundElement[2]; }
					if ( mainthis.movingItem ) { stopLoop = true; }
				}
		});
		
		if ( this.movingItem )
			{
				var item = this.whiteboard.canvasLines[this.movingItem-1];
				
				if ( this.chosenShape == 5 )
					{
						this.eraseShape(this.movingItem-1);
						return false;
					}
				
				this.deleteBackground();
				this.canvasWrap.style.cursor = 'all-scroll';
				if ( shapeNum !== false && shapeNum != 3 ) { this.chooseShape(shapeNum); }
				if ( shapeName ) { shapeName.setAttribute('style', 'background-color:#6D118C!important;'); }
			}
		else
			{
				this.startDrawingShape(e, mouseX, mouseY);
			}
	}
	
	mouseUp(e) {
		if ( window.virtualInProgress )
			{
				var checkFlutterVirtual = window.virtualInProgress();
				if ( checkFlutterVirtual ) { return false; }
			}
		if ( this.pauseDrawing || (!this.guestUser && this.whiteboard.measuringProcess && !this.movingItem) ) { return false; }
		if ( e ) { e.preventDefault(); }
		
		var mousePosition = this.getMousePosition(e);
		var mouseX = mousePosition['x'];		
		var mouseY = mousePosition['y'];
		
		if ( !this.chosenEditEl && this.mouseDown )
			{
				this.finishDrawingShape(e, mouseX, mouseY);
			}
		
		this.canvasWrap.style.cursor = 'crosshair';
				
		if ( this.chosenShape == 5 )
			{
				this.canvasWrap.setAttribute('style', 'cursor: '+this.eraserLink+',auto;');
			}
		
		if ( !window['showInstructions'+this.id] && window['allPartDetails'][this.id] ) 
			{ 
				var email = this.guestUser ? this.currentUserData['sessionData']['hostEmail'] : window['allPartDetails'][this.id]['email'];
				console.log(this.whiteboard.canvasLines, email, 'checkTest'); 
				this.whiteboard.sendDrawRTM(email); 
			}
			
		if ( window['highlightActive'] ) { window['highlightChanges'](); }
		
		this.movingItem = false;
		this.chosenEditEl = false;
		this.prevX = undefined;
		this.prevY = undefined;
		this.currX = undefined;
		this.currY = undefined;
		this.mouseDown = false;
	}
	
	mouseOut(e) {
		if ( window.virtualInProgress )
			{
				var checkFlutterVirtual = window.virtualInProgress();
				if ( checkFlutterVirtual ) { return false; }
			}
		
		if ( this.chosenShape == 4 && this.stPoint )
			{
				this.joinedLines = [];
				this.stPoint = false;
				
				this.whiteboard.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
				this.whiteboard.drawLines();
			}
		
		if ( this.chosenShape == 12 && this.angleDots.length > 0 )
			{
				this.angleDots = [];
				
				this.whiteboard.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
				this.whiteboard.drawLines();
			}
			
		if ( this.stPoint )
			{
				this.stPoint = false;
			}
			
		if ( this.chosenShape == 3 )
			{
				this.currentFreeLine = [];
			}
			
		if ( this.chosenShape == 5 )
			{
				this.mouseUp();
			}
		
		this.mouseDown = false;
		console.log(this.mouseDown, 'mouseDown mouseOut');
	}
	
	mouseMove(e) {
		let mainthis = this;
		if ( window.virtualInProgress )
			{
				var checkFlutterVirtual = window.virtualInProgress();
				if ( checkFlutterVirtual ) { return false; }
			}
		if ( !this.whiteboard.viewCaptured && this.whiteboard.hasEquipment && !this.whiteboard.measuringProcess && this.whiteboard.hasConeScript ) { return false; }
		if ( ( !window['showInstructions'+this.id] && !this.guestUser && this.whiteboard.hasEquipment && !this.whiteboard.measuringProcess && this.whiteboard.hasConeScript && !this.onDemand ) || ( !window['showInstructions'] && !this.guestUser && this.whiteboard.hasEquipment && !this.whiteboard.measuringProcess && this.onDemand ) ) { return false; }
		if ( !window['showInstructions'] && this.guestUser && this.whiteboard.hasEquipment && !this.whiteboard.measuringProcess && this.whiteboard.hasConeScript ) { return false; }
		if ( this.whiteboard.roomSetupStarted ) { return false; }
		if ( this.pauseDrawing ) { return false; }
		
		var mousePosition = this.getMousePosition(e);
		var mouseX = mousePosition['x'];		
		var mouseY = mousePosition['y'];
		
		if ( this.mouseDown )
			{
				if ( this.guestUser && !this.movingItem ) { return false; }
				if ( !this.guestUser && this.whiteboard.measuringProcess && !this.movingItem ) { return false; }
				
				this.whiteboard.drawLines();
				
				this.editDot.style.display = 'none';
				if ( this.chosenShape == 0 )
					{
						if ( !this.chosenEditEl )
							{
								if ( this.movingItem )
									{
										var linewidth = this.whiteboard.canvasLines[this.movingItem-1]['stPoint']['x'] - this.whiteboard.canvasLines[this.movingItem-1]['endPoint']['x'];
										var lineheight = this.whiteboard.canvasLines[this.movingItem-1]['stPoint']['y'] - this.whiteboard.canvasLines[this.movingItem-1]['endPoint']['y'];
									
										this.whiteboard.canvasLines[this.movingItem-1]['stPoint']['x'] = mouseX + linewidth/2;
										this.whiteboard.canvasLines[this.movingItem-1]['stPoint']['y'] = mouseY + lineheight/2;
										this.whiteboard.canvasLines[this.movingItem-1]['endPoint']['x'] = mouseX - linewidth/2;
										this.whiteboard.canvasLines[this.movingItem-1]['endPoint']['y'] = mouseY - lineheight/2;
									}
								else 
									{
										var lineStructure = {'moveX': this.stPoint.x, 'moveY': this.stPoint.y, 'lineX': mouseX, 'lineY': mouseY, 'strokeColor': this.strokeColor, 'lineWidth': this.linesWidth};
										this.whiteboard.elementDraw.mainLineDraw(this.whiteboard.ctx, lineStructure);
									}									
							}
						else
							{
								if ( this.startPoint == 0 )
									{
										this.whiteboard.canvasLines[this.chosenEditEl]['stPoint'].x = mouseX;
										this.whiteboard.canvasLines[this.chosenEditEl]['stPoint'].y = mouseY;
									}
								else
									{
										this.whiteboard.canvasLines[this.chosenEditEl]['endPoint'].x = mouseX;
										this.whiteboard.canvasLines[this.chosenEditEl]['endPoint'].y = mouseY;
									}
							}	
					}
				else if ( this.chosenShape == 1 )
					{
						if ( !this.chosenEditEl )
							{
								if ( this.movingItem )
									{
										this.whiteboard.canvasLines[this.movingItem-1]['startX'] = mouseX - this.whiteboard.canvasLines[this.movingItem-1]['w']/2;
										this.whiteboard.canvasLines[this.movingItem-1]['startY'] = mouseY;
										
										var rectSize = this.calcHeight(this.whiteboard.canvasLines[this.movingItem-1]);
										
										this.whiteboard.canvasLines[this.movingItem-1]['cmH'] = rectSize['h'];
										this.whiteboard.canvasLines[this.movingItem-1]['cmW'] = rectSize['w'];
									}
								else 
									{
										this.rect.w = (mouseX - this.canvasWrap.offsetLeft) - this.rect.startX;
										this.rect.h = (mouseY - this.canvasWrap.offsetTop) - this.rect.startY;
										
										this.whiteboard.ctx.strokeStyle = this.strokeColor;
										this.whiteboard.ctx.lineWidth = this.rect.lineW;
										this.whiteboard.ctx.strokeRect(this.rect.startX, this.rect.startY, this.rect.w, this.rect.h);
										
										var rectSize = this.calcHeight(this.rect);
										
										this.rect['cmH'] = rectSize['h'];
										this.rect['cmW'] = rectSize['w'];
										
										if ( rectSize['h'] > 0 )
											{
												var textSide = this.rect.w < 0 ? this.rect.startX - 60 : this.rect.startX + this.rect.w - 60;
												var heightText = this.inToFt(rectSize['h']);
												
												var textStructure = {'text': heightText, 'startX': textSide, 'startY': this.rect.startY + this.rect.h/2 + 10, 'font': 'bold 25px Arial', 'strokeColor': '#000', 'fillStyle': this.strokeColor, 'lineWidth': 4};
												this.whiteboard.elementDraw.writeText(this.whiteboard.ctx, textStructure);
											}
									}									
							}
						else 
							{
								this.whiteboard.canvasLines[this.chosenEditEl]['w'] = (mouseX - this.canvasWrap.offsetLeft) - this.whiteboard.canvasLines[this.chosenEditEl].startX;
								this.whiteboard.canvasLines[this.chosenEditEl]['h'] = (mouseY - this.canvasWrap.offsetTop) - this.whiteboard.canvasLines[this.chosenEditEl].startY;
								
								var rectSize = this.calcHeight(this.whiteboard.canvasLines[this.chosenEditEl]);
								
								this.whiteboard.canvasLines[this.chosenEditEl]['cmH'] = rectSize['h'];
								this.whiteboard.canvasLines[this.chosenEditEl]['cmW'] = rectSize['w'];
							}							
					}
				else if ( this.chosenShape == 2 )
					{
						if ( this.movingItem )
							{
								var linewidth = this.whiteboard.canvasLines[this.movingItem-1]['x1'] - this.whiteboard.canvasLines[this.movingItem-1]['x2'];
								var lineheight = this.whiteboard.canvasLines[this.movingItem-1]['y1'] - this.whiteboard.canvasLines[this.movingItem-1]['y2'];
								
								if ( !this.whiteboard.canvasLines[this.movingItem-1]['heightC'] && !this.whiteboard.canvasLines[this.movingItem-1]['workoutC'] )
									{
										this.whiteboard.canvasLines[this.movingItem-1]['x1'] = mouseX + linewidth/2;
										this.whiteboard.canvasLines[this.movingItem-1]['x2'] = mouseX - linewidth/2;
									}
								else
									{
										if ( mouseY < this.canvas.height/2 )
											{
												mouseY = this.canvas.height/2;
											}
									}
								
								this.whiteboard.canvasLines[this.movingItem-1]['y1'] = mouseY;
								this.whiteboard.canvasLines[this.movingItem-1]['y2'] = mouseY - lineheight;
								
								if ( !this.whiteboard.canvasLines[this.movingItem-1]['hidden'] )
									{
										// draw ellipse
										this.whiteboard.drawEllipse(this.whiteboard.canvasLines[this.movingItem-1]['x1'], this.whiteboard.canvasLines[this.movingItem-1]['y1'], this.whiteboard.canvasLines[this.movingItem-1]['x2'], this.whiteboard.canvasLines[this.movingItem-1]['y2'], this.whiteboard.canvasLines[this.movingItem-1]['cl'], this.whiteboard.canvasLines[this.movingItem-1]['lineW']);
									}
							}
						else 
							{
								var circle = this.canvas.getBoundingClientRect();
								var x2 = mouseX;
								var y2 = mouseY;
								
								if ( this.tablete || this.android )
									{
										x2 = e.changedTouches[0].clientX - window.$('#sessionCanvas' + this.id).offset().left;
										y2 = e.changedTouches[0].clientY - window.$('#sessionCanvas' + this.id).offset().top; 
									
									}
									
								this.whiteboard.drawEllipse(this.x1, this.y1, x2, y2, this.strokeColor, this.linesWidth);
								
								var lineStructure = {'moveX': 0, 'moveY': this.y1, 'lineX': this.canvas.width, 'lineY': this.y1, 'strokeColor': this.strokeColor, 'lineWidth': this.linesWidth};
								if ( this.y1 < this.y2 )
									{
										lineStructure.moveY = y2;
										lineStructure.lineY = y2;
									}
							}							
					}
				else if ( this.chosenShape == 3 )
					{
						
						this.prevX = this.currX;
						this.prevY = this.currY;
						this.currX = mouseX;
						this.currY = mouseY;
						
						var coords = {
							"x1" : this.prevX,
							"y1" : this.prevY,
							"x2" : this.currX,
							"y2" : this.currY,
							"cl" : this.strokeColor,
							"lineW" : this.linesWidth
						};
						
						this.currentFreeLine.push(coords);
						this.currentFreeLine.forEach(function(item, index) {
							if ( index > 0 )
								{
									var lineStructure = {'moveX': item['x1'], 'moveY': item['y1'], 'lineX': item['x2'], 'lineY': item['y2'], 'strokeColor': item['cl'], 'lineWidth': item['lineW']};
									mainthis.whiteboard.elementDraw.mainLineDraw(mainthis.whiteboard.ctx, lineStructure);
								}
						});
					}
				else if ( this.chosenShape == 5 )
					{
						this.whiteboard.canvasLines.forEach(function(item, index) {
							if ( item['stPoint'] )
								{
									var d = mainthis.distFromLine(e, item['stPoint'].x, item['endPoint'].x, item['stPoint'].y, item['endPoint'].y);
									
									if ( d < 5 )
										{
											mainthis.whiteboard.canvasLines.splice(index, 1);
										}
								}
							else if ( item['t'] == 'r' )
								{
									var foundRect = mainthis.distFromRect(e, item, index);
									
									if ( foundRect )
										{
											mainthis.whiteboard.canvasLines.splice(foundRect-1, 1);
										}
								}
							else if ( item['t'] == 'c' )
								{
									var foundCircle = mainthis.distFromCircle(e, item, index);
									
									if ( foundCircle )
										{
											mainthis.whiteboard.canvasLines.splice(foundCircle-1, 1);
										}
								}
							else if ( item['t'] == 'ladder' || item['t'] == 'cone' || item['t'] == 'cone_diagonal' || item['t'] == 'box' || item['t'] == 'hurdle' || item['t'] == 'bag' || item['t'] == 'ball' || item['t'] == 'boxJump' || item['t'] == 'reactionDrill' || item['t'] == 'plankForward' || item['t'] == 'plankReach' || item['t'] == 'resistedSideStepping' || item['t'] == 'lunge' )
								{
									if ( item['startX'] < mouseX && item['startY'] < mouseY && ( item['startX'] + item['w'] > mouseX ) && ( item['startY'] + item['h'] > mouseY ) )
										{
											if ( item['t'] == 'cone' || item['t'] == 'cone_diagonal' )
												{
													if ( item['side'] && item['side'] == 'r' )
														{
															mainthis.whiteboard.canvasLines.splice(index, 2);
														}
													else if ( item['side'] && item['side'] == 'l' )
														{
															mainthis.whiteboard.canvasLines.splice(index-1, 2);
														}
													else if ( !item['side'] )
														{
															mainthis.whiteboard.canvasLines.splice(index, 1);
														}
												}
											else
												{
													mainthis.whiteboard.canvasLines.splice(index, 1);
												}
										}
								}
							else if ( Array.isArray(item) )
								{
									if ( item[1] && item[1]['x1'] )
										{
											for (let item2 of item) {
												var diffX = item2['x1'] - mouseX;
												var endDiffX = item2['x2'] - mouseX;
												var diffY = item2['y1'] - mouseY;
												var endDiffY = item2['y2'] - mouseY;
												
												if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
													{
														mainthis.whiteboard.canvasLines.splice(index, 1);
														break;
													}
											}
										}
									else if ( item[1] && item[1]['x'] )
										{
											for ( var i = 1; i <= 2; i++ )
												{
													var d = mainthis.distFromLine(e, item[0]['x'], item[i]['x'], item[0]['y'], item[i]['y']);
													
													if ( d < 5 )
														{
															mainthis.whiteboard.canvasLines.splice(index, 1);
														}
												}
										}
								}
						});
					}
				else if ( ( this.chosenShape == 6 ||  this.chosenShape == 7 || this.chosenShape == 9 || this.chosenShape == 10 || this.chosenShape == 11 || this.chosenShape == 8 ) && this.movingItem )
					{
						var conePos = mouseX - this.whiteboard.canvasLines[this.movingItem-1]['w']/2;
						
						if ( this.chosenShape == 7 )
							{
								if ( this.whiteboard.canvasLines[this.movingItem-1]['side'] && this.whiteboard.canvasLines[this.movingItem-1]['side'] == 'r' )
									{
										var halfPoint = this.canvas.width/2 + 10;
										conePos = conePos >= halfPoint ? conePos : halfPoint;
										
										var secondConePos = 0 + (this.canvas.width-mouseX) - this.whiteboard.canvasLines[this.movingItem]['w']/2;
										var secondHalfPoint = this.canvas.width/2 - this.whiteboard.canvasLines[this.movingItem]['w'] - 10;
										
										secondConePos = secondConePos <= secondHalfPoint ? secondConePos : secondHalfPoint;
										var coneDiff = 0;
										
										if ( this.whiteboard.workoutAreaSetupDone )
											{
												coneDiff = this.whiteboardworkoutConeLocation['bottomRight']['posY'] - this.whiteboard.workoutConeLocation['topLeft']['posY'];
											}
											
										this.whiteboard.canvasLines[this.movingItem]['startX'] = secondConePos;
										
										if ( this.whiteboard.globalActType == 'lateralCone' ) 
											{ 
												this.whiteboard.canvasLines[this.movingItem]['startY'] = mouseY - this.whiteboard.canvasLines[this.movingItem]['h']/2; 
											}
										else 
											{ 
												this.whiteboard.canvasLines[this.movingItem]['startY'] = mouseY - this.whiteboard.canvasLines[this.movingItem]['h']/2 + coneDiff; 
											}		
									}
								else if ( this.whiteboard.canvasLines[this.movingItem-1]['side'] && this.whiteboard.canvasLines[this.movingItem-1]['side'] == 'l'  ) 
									{
										var halfPoint = this.canvas.width/2 - this.whiteboard.canvasLines[this.movingItem-2]['w'] - 10;
										conePos = conePos <= halfPoint ? conePos : halfPoint;
										
										var secondConePos = this.canvas.width - (0 + mouseX) - this.whiteboard.canvasLines[this.movingItem-2]['w']/2;
										var secondHalfPoint = this.canvas.width/2 + 10;
										
										secondConePos = secondConePos >= secondHalfPoint ? secondConePos : secondHalfPoint;
										var coneDiff = 0;
										
										if ( this.whiteboard.workoutAreaSetupDone )
											{
												coneDiff = this.whiteboard.workoutConeLocation['bottomRight']['posY'] - this.whiteboard.workoutConeLocation['topLeft']['posY'];
											}
											
										this.whiteboard.workoutConeLocation[this.movingItem-2]['startX'] = secondConePos;
										if ( this.whiteboard.globalActType == 'lateralCone' ) 
											{ 
												this.whiteboard.canvasLines[this.movingItem-2]['startY'] = mouseY - this.whiteboard.canvasLines[this.movingItem-2]['h']/2; 
											}
										else 
											{ 
												this.whiteboard.canvasLines[this.movingItem-2]['startY'] = mouseY - this.whiteboard.canvasLines[this.movingItem-2]['h']/2 - coneDiff; 
											}
									}									
							}
							
						let oldStartX = this.whiteboard.canvasLines[this.movingItem-1]['startX'];
						let oldStartY = this.whiteboard.canvasLines[this.movingItem-1]['startY'];

						this.whiteboard.canvasLines[this.movingItem-1]['startX'] = conePos;
						this.whiteboard.canvasLines[this.movingItem-1]['startY'] = mouseY - this.whiteboard.canvasLines[this.movingItem-1]['h']/2;

						if ( this.chosenShape == 6 && this.whiteboard.canvasLines[this.movingItem-1]['startY'] < this.canvas.height/2 ) 
							{ 
								this.whiteboard.canvasLines[this.movingItem-1]['startY'] = this.canvas.height/2; 
							}

						var startX = this.whiteboard.canvasLines[this.movingItem-1]['startX'];
						var startY = this.whiteboard.canvasLines[this.movingItem-1]['startY'];
						var shapeW = this.whiteboard.canvasLines[this.movingItem-1]['w'];
						var shapeH = this.chosenShape == 6 ? this.whiteboard.canvasLines[this.movingItem-1]['h']*2 : this.whiteboard.canvasLines[this.movingItem-1]['h'];

						var x = 0;
						var y = parseFloat((((startY + shapeH/2) / (this.canvas.height/2)) - 0.7).toFixed(2));
								
						if ( y < 0.2 ) y = 0.2;
						
						var distance = parseFloat(y / Math.sqrt(x^2 + 1)).toFixed(2);
						if ( this.guestUser ) 
							{ 
								distance = this.whiteboard.canvasLines[this.movingItem-1]['dist'] ? this.whiteboard.canvasLines[this.movingItem-1]['dist'] : 1; 
							}
						
						var itemWidth = parseInt(this.whiteboard.imgList[this.chosenShape][0]);
						var itemHeight = parseInt(this.whiteboard.imgList[this.chosenShape][1]);	

						if ( this.chosenShape == 8 && this.whiteboard.currentEquipment == 'boxJump' && !this.guestUser && !this.onDemand )
							{
								itemWidth = this.whiteboard.boxJumpWidth;
								itemHeight = this.whiteboard.boxJumpHeight;
							}

						if ( this.chosenShape == 8 && ( this.whiteboard.currentEquipment == 'plankForward' || this.whiteboard.currentEquipment == 'plankReach' ) && !this.guestUser && !this.onDemand )
							{
								if ( this.whiteboard.currentEquipment == 'plankForward' )
									{
										itemWidth = this.whiteboard.plankWidth;
										itemHeight = this.whiteboard.plankHeight;
									}
								else if ( this.whiteboard.currentEquipment == 'plankReach' )
									{
										itemWidth = this.whiteboard.plankReachWidth;
										itemHeight = this.whiteboard.plankReachHeight;
									}
							}

						if ( this.chosenShape == 7 ) 
							{ 
								let coneSizeList = this.whiteboard.newConesSize['newConeBig'];
								itemWidth = coneSizeList[0];
								itemHeight = coneSizeList[1];
								
								distance = y;
							}

						if( this.chosenShape == 6 )
							{
								distance = y;
								
								itemWidth = this.whiteboard.ladderDraw.ladderDimensions['w'];
								itemHeight = this.whiteboard.ladderDraw.ladderDimensions['h'];
								this.whiteboard.ladderDraw.ladderMoved = true;
							}
						
						var newW = Math.round(itemWidth * distance);
						var newH = Math.round(itemHeight * distance);	
						
						if ( this.chosenShape == 8 )
							{
								newW = Math.round(itemWidth * y);
								newH = Math.round(itemHeight * y);
							}
							
						if ( this.chosenShape == 10 )
							{
								distance = distance * 4;
							
								var bagRatio = itemWidth / itemHeight;
				
								this.whiteboard.canvasLines[this.movingItem-1]['startY'] = 0;
								
								newH = mouseY;
								newW = this.whiteboard.canvasLines[this.movingItem-1]['h']*bagRatio;
							}

						if ( newW < 2 ) { newW = 2; }
						if ( newH < 2 ) { newH = 2; }

						let useSamePosition = false;

						if ( (oldStartX == startX) || (oldStartY == startY) )
							{
								newW = shapeW;
								newH = this.whiteboard.canvasLines[this.movingItem-1]['h'];							
								useSamePosition = true;
							}

						this.whiteboard.canvasLines[this.movingItem-1]['w'] = newW;
						this.whiteboard.canvasLines[this.movingItem-1]['h'] = newH;
						this.whiteboard.canvasLines[this.movingItem-1]['dist'] = y;

						if ( this.chosenShape == 6 )
							{
								this.whiteboard.canvasLines[this.movingItem-1]['startX'] = this.canvas.width/2 - newW/2;
								this.whiteboard.canvasLines[this.movingItem-1]['fieldStartX'] = this.whiteboard.canvasLines[this.movingItem-1]['startX']+((80*distance)+(this.whiteboard.canvasLines[this.movingItem-1]['fieldDiff']/4)*distance);
								this.whiteboard.canvasLines[this.movingItem-1]['fieldEndX'] =  this.whiteboard.canvasLines[this.movingItem-1]['startX'] + this.whiteboard.canvasLines[this.movingItem-1]['w'] - ((80*distance)-(this.whiteboard.canvasLines[this.movingItem-1]['fieldDiff']/4)*distance);
							}

						if ( this.chosenShape == 7 && this.whiteboard.canvasLines[this.movingItem-1]['side'] )
							{
								var secondConeInd = this.whiteboard.canvasLines[this.movingItem-1]['side'] == 'r' ? this.movingItem : this.movingItem-2;
								var secondConeDist = parseFloat((((this.whiteboard.canvasLines[secondConeInd]['startY'] + shapeH/2) / (this.canvas.height/2)) - 0.7).toFixed(2));
								if ( secondConeDist < 0.2 ) secondConeDist = 0.2;
									
								var secondConeW = Math.round(itemWidth * secondConeDist); 
								var secondConeH = Math.round(itemHeight* secondConeDist);
									
								this.whiteboard.canvasLines[secondConeInd]['w'] = secondConeW;
								this.whiteboard.canvasLines[secondConeInd]['h'] = secondConeH;
								this.whiteboard.canvasLines[secondConeInd]['dist'] = secondConeDist;
							}
						if ( useSamePosition ) { this.movingItem = false; }	
					}
				
				else if ( this.chosenShape == 12 )
					{
						if ( !this.chosenEditEl )
							{
								if ( this.movingItem )
									{
										var linewidth1 = this.whiteboard.canvasLines[this.movingItem-1][0]['x'] - this.whiteboard.canvasLines[this.movingItem-1][1]['x'];
										var lineheight1 = this.whiteboard.canvasLines[this.movingItem-1][0]['y'] - this.whiteboard.canvasLines[this.movingItem-1][1]['y'];
										var linewidth2 = this.whiteboard.canvasLines[this.movingItem-1][0]['x'] - this.whiteboard.canvasLines[this.movingItem-1][2]['x'];
										var lineheight2 = this.whiteboard.canvasLines[this.movingItem-1][0]['y'] - this.whiteboard.canvasLines[this.movingItem-1][2]['y'];
										
										this.whiteboard.canvasLines[this.movingItem-1][0]['x'] = mouseX;
										this.whiteboard.canvasLines[this.movingItem-1][0]['y'] = mouseY;
										this.whiteboard.canvasLines[this.movingItem-1][1]['x'] = mouseX - linewidth1;
										this.whiteboard.canvasLines[this.movingItem-1][1]['y'] = mouseY - lineheight1;
										this.whiteboard.canvasLines[this.movingItem-1][2]['x'] = mouseX - linewidth2;
										this.whiteboard.canvasLines[this.movingItem-1][2]['y'] = mouseY - lineheight2;
									}
							}
						else 
							{
								this.whiteboard.canvasLines[this.chosenEditEl][this.startPoint].x = mouseX;
								this.whiteboard.canvasLines[this.chosenEditEl][this.startPoint].y = mouseY;
								
								var angleStructure = {'x1': this.whiteboard.canvasLines[this.chosenEditEl][1].x, 'x2': this.whiteboard.canvasLines[this.chosenEditEl][0].x, 'x3': this.whiteboard.canvasLines[this.chosenEditEl][2].x, 'y1': this.whiteboard.canvasLines[this.chosenEditEl][1].y, 'y2': this.whiteboard.canvasLines[this.chosenEditEl][0].y, 'y3': this.whiteboard.canvasLines[this.chosenEditEl][2].y};
								var degree_angle = this.calculateAngle(angleStructure);
								
								this.whiteboard.canvasLines[this.chosenEditEl][2]['deg'] = degree_angle;
							}							
					}
				else if ( this.chosenShape == 13 && this.movingItem )
					{
						this.whiteboard.canvasLines[this.movingItem-1]['startY'] = mouseY - this.whiteboard.canvasLines[this.movingItem-1]['h']/2;
					}
					
			}
		else 
			{
				var stopLoop = false;
				if ( this.chosenShape != 5 )
					{
						if ( this.chosenShape == 4 && this.stPoint )
							{
								this.whiteboard.drawLines(); //draw previous lines
								
								var lineStructure = {'moveX': this.stPoint.x, 'moveY': this.stPoint.y, 'lineX': mouseX, 'lineY': mouseY, 'strokeColor': this.strokeColor, 'lineWidth': this.linesWidth};
								this.whiteboard.elementDraw.mainLineDraw(this.whiteboard.ctx, lineStructure);
							}
							
						else if ( this.chosenShape == 12 && this.angleDots.length > 0 )
							{
								this.whiteboard.drawLines(); //draw previous lines
								
								var angleStructure = {'moveX': this.angleDots[0].x, 'moveY': this.angleDots[0].y, 'lineX': mouseX, 'lineY': mouseY, 'strokeColor': this.strokeColor, 'lineWidth': this.linesWidth}
								this.whiteboard.elementDraw.mainLineDraw(this.whiteboard.ctx, angleStructure);
								
								if ( this.angleDots.length > 1 )
									{								
										var angleStructure2 = {'moveX': this.angleDots[0].x, 'moveY': this.angleDots[0].y, 'lineX': this.angleDots[1].x, 'lineY': this.angleDots[1].y, 'strokeColor': this.angleDots[0]['cl'], 'lineWidth': this.linesWidth}
										this.whiteboard.elementDraw.mainLineDraw(this.whiteboard.ctx, angleStructure2);
										
										var angleStructure = {'x1': this.angleDots[1].x, 'x2': this.angleDots[0].x, 'x3': mouseX, 'y1': this.angleDots[1].y, 'y2': this.angleDots[0].y, 'y3': mouseY};
										var degree_angle = this.calculateAngle(angleStructure);
										
										var textStructure = {'text': degree_angle+'°', 'startX': this.angleDots[0].x + 10, 'startY': this.angleDots[0].y + 10, 'font': 'bold 25px Arial', 'strokeColor': '#000', 'fillStyle': this.angleDots[0]['cl'], 'lineWidth': 4};
										this.whiteboard.elementDraw.writeText(this.whiteboard.ctx, textStructure);
									}
							}
						else 
							{
								let mainthis = this;
								mainthis.canvasWrap.style.cursor = 'crosshair';
								
								mainthis.whiteboard.canvasLines.forEach(function(item, index) {
									if ( item['stPoint'] )
										{
											var d = mainthis.distFromLine(e, item['stPoint'].x, item['endPoint'].x, item['stPoint'].y, item['endPoint'].y);
											
											if ( d < 5 )
												{
													mainthis.canvasWrap.style.cursor = 'all-scroll';
												}
											
											if ( item['t'] != 'j' )
												{
													var diffX = item['stPoint'].x - mouseX;
													var endDiffX = item['endPoint'].x - mouseX;
													var diffY = item['stPoint'].y - mouseY;
													var endDiffY = item['endPoint'].y - mouseY;
													
													if ( !stopLoop )
														{
															if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
																{
																	mainthis.showEditDot(item['stPoint'].x-3, item['stPoint'].y-3, item['cl']);
																	stopLoop = true;
																}
															else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > -5 && endDiffY < 5 )
																{
																	mainthis.showEditDot(item['endPoint'].x-3, item['endPoint'].y-3, item['cl']);
																	stopLoop = true;
																}
															else
																{
																	mainthis.editDot.style.display = 'none';
																}
														}
												}
										}
									else if ( item['t'] == 'r' ) 
										{
											var foundRect = mainthis.distFromRect(e, item, index);
											
											var diffX = item['startX'] - mouseX;
											var endDiffX = (item['startX'] + item['w']) - mouseX;
											var diffY = item['startY'] - mouseY;
											var endDiffY = (item['startY'] + item['h']) - mouseY;
											
											if ( foundRect )
												{
													mainthis.canvasWrap.style.cursor = 'all-scroll';
												}
											
											if ( !stopLoop )
												{
													if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
														{
															mainthis.showEditDot(item['startX']-3, item['startY']-3, item['cl']);
															stopLoop = true;
														}
													else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > -5 && endDiffY < 5 )
														{
															mainthis.showEditDot(item['startX'] + item['w']-3, item['startY'] + item['h']-3, item['cl']);
															stopLoop = true;
														}
													else
														{
															mainthis.editDot.style.display = 'none';
														}
												}
										}
									else if ( item['t'] == 'c' )
										{
											var foundCircle = mainthis.distFromCircle(e, item, index);
											
											if ( foundCircle )
												{
													mainthis.canvasWrap.style.cursor = 'all-scroll';
												}
										}
									else if ( item['t'] == 'ladder' || item['t'] == 'cone' || item['t'] == 'cone_diagonal' || item['t'] == 'box' || item['t'] == 'hurdle' || item['t'] == 'bag' || item['t'] == 'ball' || item['t'] == 'squat' || item['t'] == 'boxJump' || item['t'] == 'reactionDrill' || item['t'] == 'plankForward' || item['t'] == 'plankReach' || item['t'] == 'resistedSideStepping' || item['t'] == 'lunge' )
										{
											if ( item['startX'] < mouseX && item['startY'] < mouseY && ( item['startX'] + item['w'] > mouseX ) && ( item['startY'] + item['h'] > mouseY ) )
												{
													mainthis.canvasWrap.style.cursor = 'all-scroll';
												}
										}
									else if ( Array.isArray(item) )
										{
											item.forEach(function(item2, index2) {
												if ( item2['x'] )
													{
														if ( index2 > 0 )
															{
																var d = mainthis.distFromLine(e, item[0].x, item2.x, item[0].y, item2.y);
									
																if ( d < 5 )
																	{
																		mainthis.canvasWrap.style.cursor = 'all-scroll';
																	}
																
																var diffX = item2.x - mouseX;
																var diffY = item2.y - mouseY;
																if ( !stopLoop )
																	{
																		if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
																			{
																				mainthis.showEditDot(item2.x-3, item2.y-3, item2['cl']);
																				stopLoop = true;
																			}
																		else
																			{
																				mainthis.editDot.style.display = 'none';
																			}
																	}
															}
													}
											});
										}
								});
							}							
					}
			}			
	}
	
	showEditDot(left, top, color) {
		this.editDot.style.display = 'block';
		this.editDot.style.left = left+'px';
		this.editDot.style.top = top+'px';
		
		if ( this.electron )
			{
				var topDiff = this.canvas.offsetTop;
				this.editDot.style.top = top+topDiff+'px';
			}
			
		this.editDot.style.backgroundColor = color;
		this.canvasWrap.style.cursor = 'n-resize';
	}
	
	chooseEditElement(index, stPoint, shapeNum, shapeName) {
		this.chosenEditEl = index;
		this.startPoint = stPoint;
		this.chooseShape(shapeNum);
		this.deleteBackground();
		this.shapeName.setAttribute('style', 'background-color:#6D118C!important;');
		this.canvasWrap.style.cursor = 'n-resize';
	}
	
	editDown() {
		var leftNum = parseInt(this.editDot.style.left.split('p')[0]);
		var topNum = parseInt(this.editDot.style.top.split('p')[0]);
		
		if ( window['electron'] )
			{
				topNum = topNum - this.canvas.offsetTop;
			}
		let mainthis = this;
		this.whiteboard.canvasLines.forEach(function(item, index) {
			if ( item['stPoint'] && item['t'] != 'j' )
				{
					var diffX = item['stPoint'].x - leftNum;
					var endDiffX = item['endPoint'].x - leftNum;
					var diffY = item['stPoint'].y - topNum;
					var endDiffY = item['endPoint'].y - topNum;

					if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
						{
							mainthis.chooseEditElement(index, 0, 0, mainthis.canvasLine);
						}
					else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > -5 && endDiffY < 5 )
						{
							mainthis.chooseEditElement(index, 1, 0, mainthis.canvasLine);
						}
				}
			else if ( item['t'] == 'r' ) 
				{
					var diffX = item['startX'] - leftNum;
					var endDiffX = (item['startX'] + item['w']) - leftNum;
					var diffY = item['startY'] - topNum;
					var endDiffY = (item['startY'] + item['h']) - topNum;
					
					if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
						{
							mainthis.chooseEditElement(index, 0, 1, mainthis.canvasSquare);
						}
					else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > -5 && endDiffY < 5 )
						{
							mainthis.chooseEditElement(index, 1, 1, mainthis.canvasSquare);
						}
				}
			else if ( Array.isArray(item) )
				{
					item.forEach(function(item2, index2) {
						if ( index2 > 0 )
							{
								if ( item2['x'] )
									{
										var diffX = item2['x'] - leftNum;
										var diffY = item2['y'] - topNum;
										
										if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
											{
												mainthis.chooseEditElement(index, index2, 12, mainthis.canvasAngle);
											}
									}
							}
					});
				}
		});
		
		mainthis.mouseDown = true;
	}
	
	calcHeight(item) {
		var itemH = item['h'];
		var itemY = item['startY'];
		
		if ( itemH < 0 )
			{
				itemH = itemH * -1;
				itemY = itemY - itemH;
			}
		
		var dist = parseFloat((((itemY + itemH) / (this.canvas.height/2)) - 1).toFixed(2));
		var itemHeight = itemH;
		var itemWidth = item['w'];
		//var distance = parseFloat(dist / Math.sqrt(0^2 + 1));
		var objectWidth = parseInt(itemWidth * (this.pxPerMm/dist))/10;
		var objectHeight = parseInt(itemHeight * (this.pxPerMm/dist))/10;
		var finalWidth = Math.abs(((objectWidth)/2.54)).toFixed(1);
		var finalHeight = Math.abs(((objectHeight)/2.54)).toFixed(1);
		
		if ( dist < 0.2 ) { finalHeight = 0 }
		
		if ( !window['heightCaptured'] ) { finalHeight = -1 }
		
		var obj = {
			'h' : finalHeight,
			'w' : finalWidth
		};
		
		return obj;
	}
	
	chooseShape(mod, coneSide) {
		this.stPoint = false;
		this.chosenShape = mod;
		if ( this.chosenShape != 3 ) { this.currentFreeLine = []; }
		if ( this.chosenShape != 4 ) { this.joinedLines = []; }
		if ( this.chosenShape != 12 ) { this.angleDots = []; }
		
		this.canvasWrap.style.cursor = 'crosshair';
		if ( mod == 5 ) { this.canvasWrap.setAttribute('style', 'cursor: '+this.eraserLink+',auto;'); }
			
		if ( window.showFMSPalette ) { window.showFMSPalette(this.id); }
	}
	
	distFromLine(e, x1, x2, y1, y2) {
		var mousePosition = this.getMousePosition(e);
		var mouseX = mousePosition['x'];		
		var mouseY = mousePosition['y'];
		
		var x = mouseX;
		var y = mouseY;
		var lineX1 = x1;
		var x2 = x2;
		var lineY1 = y1;
		var y2 = y2;
			
		var A = x - lineX1;
		var B = y - lineY1;
		var C = x2 - lineX1;
		var D = y2 - lineY1;

		var dot = A * C + B * D;
		var len_sq = C * C + D * D;
		var param = -1;
		if (len_sq != 0) //in case of 0 length line
		param = dot / len_sq;

		var xx, yy;

		if (param < 0) {
			xx = lineX1;
			yy = lineY1;
		}
		else if (param > 1) {
			xx = x2;
			yy = y2;
		}
		else {
			xx = lineX1 + param * C;
			yy = lineY1 + param * D;
		}

		var dx = x - xx;
		var dy = y - yy;
		var d = Math.sqrt(dx * dx + dy * dy);
		
		return d;
	}
	
	distFromRect(e, item, index) {
		var mousePosition = this.getMousePosition(e);
		var mouseX = mousePosition['x'];		
		var mouseY = mousePosition['y'];
		
		var startX = item['startX'];
		var startY = item['startY'];
		var itemW = item['w'];
		var itemH = item['h'];
		
		var diffX = startX - mouseX;
		var endDiffX = startX + itemW - mouseX;
		var diffY = startY - mouseY;
		var endDiffY = startY + itemH - mouseY;
		var found = false;
		
		if ( itemW > 0 && itemH > 0 )
			{
				if ( diffY > -5 && diffY < 5 && endDiffX > -5 && endDiffX < itemW )
					{
						found = index + 1;
					}
				else if ( diffX > -5 && diffX < 5 && endDiffY > -5 && endDiffY < itemH )
					{
						found = index + 1;
					}
				else if ( endDiffY > -5 && endDiffY < 5 && endDiffX > -5 && endDiffX < itemW )
					{
						found = index + 1;
					}
				else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > -5 && endDiffY < itemH )
					{
						found = index + 1;
					}
			}
		else if ( itemW < 0 && itemH < 0 )
			{
				if ( diffY > -5 && diffY < 5 && diffX > -5 && diffX < Math.abs(itemW) )
					{
						found = index + 1;
					}
				else if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < Math.abs(itemH) )
					{
						found = index + 1;
					}
				else if ( endDiffY > -5 && endDiffY < 5 && endDiffX > itemW && endDiffX < 5 )
					{
						found = index + 1;
					}
				else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > itemH && endDiffY < 5 )
					{
						found = index + 1;
					} 
			}
		else if ( itemW > 0 && itemH < 0 ) 
			{
				if ( diffY > -5 && diffY < 5 && endDiffX > -5 && endDiffX < itemW )
					{
						found = index + 1;
					}
				else if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < Math.abs(itemH) )
					{
						found = index + 1;
					}
				else if ( endDiffY > -5 && endDiffY < 5 && endDiffX > -5 && endDiffX < itemW )
					{
						found = index + 1;
					}
				else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > itemH && endDiffY < 5 )
					{
						found = index + 1;
					} 
			}
		else
			{
				if ( diffY > -5 && diffY < 5 && diffX > -5 && diffX < Math.abs(itemW) )
					{
						found = index + 1;
					}
				else if ( diffX > -5 && diffX < 5 && endDiffY > -5 && endDiffY < itemH )
					{
						found = index + 1;
					}
				else if ( endDiffY > -5 && endDiffY < 5 && endDiffX > itemW && endDiffX < 5 )
					{
						found = index + 1;
					}
				else if ( endDiffX > -5 && endDiffX < 5 && endDiffY > -5 && endDiffY < itemH )
					{
						found = index + 1;
					}
			}
			
		return found;
	}
	
	distFromCircle(e, item, index) {
		var mousePosition = this.getMousePosition(e);
		var mouseX = mousePosition['x'];		
		var mouseY = mousePosition['y'];
		
		var x1 = item['x1'];
		var x2 = item['x2'];
		var y1 = item['y1'];
		var y2 = item['y2'];
		
		var diffX = x1 - mouseX;
		var endDiffX = x2 - mouseX;
		var diffY = y1 - mouseY;
		var endDiffY = y2 - mouseY;
		var radiusX = Math.abs(x2 - x1);
		var radiusY = Math.abs(y2 - y1);
		var p = this.whiteboard.ctx.getImageData(mouseX, mouseY, 1, 1).data;
		var hex = "#" + ("000000" + this.rgbToHex(p[0], p[1], p[2])).slice(-6);	
		var found = false;
		
		if ( (hex == item['cl'] || item['heightC'] || item['workoutC']) && x1 < x2 && y1 < y2 )
			{
				if ( endDiffY > 0 && endDiffY <= radiusY && endDiffX > 0 && endDiffX <= radiusX )
					{
						found = index + 1;
					}
			}
		else if ( (hex == item['cl'] || item['heightC'] || item['workoutC']) && x1 > x2 && y1 > y2 )
			{
				if ( diffY > 0 && diffY <= radiusY && diffX > 0 && diffX <= radiusX )
					{
						found = index + 1;
					}
			}
		else if ( (hex == item['cl'] || item['heightC'] || item['workoutC']) && x1 < x2 && y1 > y2 ) 
			{
				if ( diffY > 0 && diffY <= radiusY && endDiffX > 0 && endDiffX <= radiusX )
					{
						found = index + 1;
					}
			}
		else if ( (hex == item['cl'] || item['heightC'] || item['workoutC']) && x1 > x2 && y1 < y2 )
			{
				if ( endDiffY > 0 && endDiffY <= radiusY && diffX > 0 && diffX <= radiusX )
					{
						found = index + 1;
					}
			}
			
		return found;
	}
	
	distFromElement(e, item, index, mouseX, mouseY) {
		var nearElement = false;
		var shapeNum = false;
		var shapeName = false;
		var mainthis = this;
		
		if ( item['stPoint'] )
			{
				var d = this.distFromLine(e, item['stPoint']['x'], item['endPoint']['x'], item['stPoint']['y'], item['endPoint']['y']);
				
				if ( d < 5 )
					{
						nearElement = true;
						shapeNum = 0;
						shapeName = this.canvasLine;
					}
			}
		else if ( item['t'] == 'r' )
			{
				var foundRect = this.distFromRect(e, item, index);
				
				if ( foundRect )
					{
						nearElement = true;
						shapeNum = 1;
						shapeName = this.canvasSquare;
					}
			}
		else if ( item['t'] == 'c' )
			{
				var foundCircle = this.distFromCircle(e, item, index);
				
				if ( foundCircle )
					{
						nearElement = true;
						shapeNum = 2;
						shapeName = this.canvasCircle;
					}
			}
		else if ( item['t'] == 'ladder' || item['t'] == 'cone' || item['t'] == 'cone_diagonal' || item['t'] == 'box' || item['t'] == 'hurdle' || item['t'] == 'bag' || item['t'] == 'ball' || item['t'] == 'squat' || item['t'] == 'boxJump' || item['t'] == 'reactionDrill' || item['t'] == 'plankForward' || item['t'] == 'plankReach' || item['t'] == 'resistedSideStepping' || item['t'] == 'lunge' )
			{
				if ( item['startX'] < mouseX && item['startY'] < mouseY && ( item['startX'] + item['w'] > mouseX ) && ( item['startY'] + item['h'] > mouseY ) )
					{
						nearElement = true;
						shapeNum = item['t'] == 'ladder' ? 6 : item['t'] == 'cone' ? 7 : item['t'] == 'cone_diagonal' ? 7 : item['t'] == 'box' ? 8 : item['t'] == 'hurdle' ? 9 : item['t'] == 'bag' ? 10 : item['t'] == 'ball' ? 11 : item['t'] == 'squat' ? 13 : item['t'] == 'boxJump' ? 8 : item['t'] == 'reactionDrill' ? 15 : item['t'] == 'plankForward' ? 8 : item['t'] == 'plankReach' ? 8 : false;
						shapeName = item['t'] == 'ladder' ? this.canvasLadder : item['t'] == 'cone' ? ( item['side'] ? this.canvasCone : this.canvasSingleCone ) : item['t'] == 'cone_diagonal' ? ( item['side'] ? this.canvasCone : this.canvasSingleCone ) : item['t'] == 'box' ? this.canvasBox : item['t'] == 'hurdle' ? this.canvasHurdle : item['t'] == 'bag' ? this.canvasBag : item['t'] == 'ball' ? this.canvasBall : false;
						
						/* if ( shapeNum != 7 || shapeNum == 7 && !item['side'] )
							{
								var item = this.whiteboard.canvasLines[this.movingItem-1];
								this.whiteboard.canvasLines.splice(this.movingItem-1, 1);
								this.whiteboard.canvasLines.push(item);
								this.movingItem = this.whiteboard.canvasLines.length;
							} */
					}
			}
		else if ( Array.isArray(item) )
			{
				item.forEach(function(item2, index2) {
					if ( item2['x1'] )
						{
							var diffX = item2['x1'] - mouseX;
							var endDiffX = item2['x2'] - mouseX;
							var diffY = item2['y1'] - mouseY;
							var endDiffY = item2['y2'] - mouseY;
							
							if ( diffX > -5 && diffX < 5 && diffY > -5 && diffY < 5 )
								{
									nearElement = true;
									shapeNum = 3;
								}
						}
					else
						{
							if ( index2 > 0 )
								{
									var d = mainthis.distFromLine(e, item[0].x, item2.x, item[0].y, item2.y);
				
									if ( d < 5 )
										{
											nearElement = true;
											shapeNum = 12;
											shapeName = mainthis.canvasAngle;
										}
								}
						}
				});
			}
			
		return [nearElement, shapeNum, shapeName];
	}
	
	startDrawingShape(e, mouseX, mouseY) {
		if ( this.chosenShape == 0 )
			{
				this.stPoint = this.createPoint(mouseX, mouseY); //get start point for line
			}
		else if ( this.chosenShape == 1 )
			{
				this.rect.startX = mouseX;
				this.rect.startY = mouseY;
				this.rect.w=0;
				this.rect.h=0;
				this.rect.cl = this.strokeColor;
				this.rect.lineW = this.linesWidth;
			}
		else if ( this.chosenShape == 2 )
			{
				var circle = this.canvas.getBoundingClientRect();
				
				if ( this.tablete || this.android )
					{
						this.x1 = e.changedTouches[0].clientX - circle.left;
						this.y1 = e.changedTouches[0].clientY - circle.top; 
					}
				else 
					{
						this.x1 = mouseX;
						this.y1 = mouseY;
					}									
			
			}
		else if ( this.chosenShape == 3 )
			{
				this.prevX = this.currX;
				this.prevY = this.currY;
				this.currX = mouseX;
				this.currY = mouseY;
				
				var coords = {
					"x1" : this.prevX,
					"y1" : this.prevY,
					"x2" : this.currX,
					"y2" : this.currY,
					"cl" : this.strokeColor,
					"lineW" : this.linesWidth
				};
				
				this.currentFreeLine.push(coords);
			}
		else if ( this.chosenShape == 12 )
			{
				if ( this.angleDots.length < 3 )
					{
						var startDot = {
							"x" : mouseX,
							"y" : mouseY,
							"cl" : this.strokeColor,
							"lineW" : this.linesWidth
						};
						
						this.angleDots.push(startDot);
					}
			}
	}
	
	finishDrawingShape(e, mouseX, mouseY) {
		if ( this.chosenShape == 0 )
			{
				if ( this.movingItem )
					{
						this.movingItem = false;
					}
				else
					{
						if ( this.stPoint )
							{
								this.endPoint = this.createPoint(mouseX, mouseY); //get end point
								this.whiteboard.canvasLines.push(this.lineP(this.stPoint, this.endPoint)); //store line points for next draw
								this.whiteboard.canvasLines[this.whiteboard.canvasLines.length-1]['cl'] = this.strokeColor;
								this.whiteboard.canvasLines[this.whiteboard.canvasLines.length-1]['lineW'] = this.linesWidth;
								this.stPoint = false;
								this.endPoint = false;
							}
					}
			}
		else if ( this.chosenShape == 1 )
			{
				if ( !this.movingItem )
					{
						this.rect.cl = this.strokeColor;
						this.rect.t = 'r';
						this.whiteboard.canvasLines.push(this.rect);
						this.rect = {};
					}
			}
		else if ( this.chosenShape == 2 ) 
			{
				if ( !this.movingItem )
					{
						this.whiteboard.canvasLines.push(this.whiteboard.circleObj);
					}
			}
		else if ( this.chosenShape == 3 )
			{
				this.whiteboard.canvasLines.push(this.currentFreeLine);
				this.currentFreeLine = [];
			}
		else if ( this.chosenShape == 4 )
			{
				if ( e.detail === 1 || this.tablete || this.android )
					{
						if ( e.which == 3 )
							{
								this.stPoint = false;
								this.joinedLines = [];
							}
						else
							{
								if ( this.joinedLines.length == 0 )
									{
										this.stPoint = this.createPoint(mouseX, mouseY);
									}
								else
									{
										this.stPoint = this.createPoint(this.joinedLines[this.joinedLines.length-1]['endPoint']['x'], this.joinedLines[this.joinedLines.length-1]['endPoint']['y']);
									}
							}
					}
				else if ( e.detail === 2 )
					{
						this.pauseClick = true;
						
						let mainthis = this;
						setTimeout(function() {
							mainthis.pauseClick = false;
						}, 500);
						
						this.mouseOut(false);
					}
			}
		else if ( (this.chosenShape == 6 || this.chosenShape == 7 || this.chosenShape == 10) && this.movingItem )
			{
				this.whiteboard.resetEquipmentZones();
			}
		else if ( this.chosenShape == 12 )
			{
				if ( !this.movingItem && this.angleDots.length == 3 )
					{
						var angleStructure = {'x1': this.angleDots[1].x, 'x2': this.angleDots[0].x, 'x3': this.angleDots[2].x, 'y1': this.angleDots[1].y, 'y2': this.angleDots[0].y, 'y3': this.angleDots[2].y};
						var degree_angle = this.calculateAngle(angleStructure);
						
						this.angleDots[2]['deg'] = degree_angle;
						
						this.whiteboard.canvasLines.push(this.angleDots);
						
						this.angleDots = [];
					}
			}
	}
	
	createPoint(x, y) {
		/* this.x = x;
		this.y = y; */
		return {'x': x, 'y': y};
	}

	lineP(stPoint, endPoint) {
		/* this.stPoint = stPoint;
		this.endPoint = endPoint; */
		return {'stPoint': this.stPoint, 'endPoint': this.endPoint};
	}
	
	eraseShape(index) {
		this.whiteboard.canvasLines.splice(index, 1);
		
		this.movingItem = false;
	}
	
	rgbToHex(r, g, b) {
	  return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
	}
	
	componentToHex(c) {
	  var hex = c.toString(16);
	  return hex.length == 1 ? "0" + hex : hex;
	}
	
	deleteBackground() {
		this.$('.palette-drawing span').css('background-color', '');
	}
	
	calculateAngle(item) {
		var dAx = item.x1 - item.x2;
		var dAy = item.y1 - item.y2;
		var dBx = item.x3 - item.x2;
		var dBy = item.y3 - item.y2;
		var angle = Math.atan2(dAx * dBy - dAy * dBx, dAx * dBx + dAy * dBy);
		if(angle < 0) {angle = angle * -1;}
		var degree_angle = Math.round(angle * (180 / Math.PI));
		
		return degree_angle;
	}
	
	/* gridSwitchAction(e){
		this.whiteboard.gridSwitch(e);
	} */
	
	drawBoard(){
		// Box width
		var bw = this.canvas.width;
		// Box height
		var bh = this.canvas.height;
		// Padding
		var p = 0;
		for (var x = 0; x <= bw; x += parseInt(this.whiteboardValues['gridW'])) {
			this.whiteboard.ctx2.moveTo(0.5 + x + p, p);
			this.whiteboard.ctx2.lineTo(0.5 + x + p, bh + p);
		}

		for (var x = 0; x <= bh; x += parseInt(this.whiteboardValues['gridH'])) {
			this.whiteboard.ctx2.moveTo(p, 0.5 + x + p);
			this.whiteboard.ctx2.lineTo(bw + p, 0.5 + x + p);
		}
		this.whiteboard.ctx2.lineWidth = 1;
		this.whiteboard.ctx2.strokeStyle = this.gridColor;
		this.whiteboard.ctx2.stroke();
	}
	
	gridSwitch(dochange, newgrid, gridcolor) {
		if ( dochange === true ) 
			{ 
				this.gridOn = newgrid; 
			} 
		else 
			{ 
				this.gridOn = !this.gridOn; 
			} 
		if ( this.gridOn )
			{
				if ( this.guestUser || this.hostVirtual ) 
					{  
						if ( this.$('#gridCanvas').length < 1 ) 
							{ 
								this.$('<canvas class="canvasGrid" id="gridCanvas" width="1280" height="720"></canvas>').insertAfter('#sessionCanvas'); 
							}
						
						this.gridCanvas = document.getElementById('gridCanvas');
						this.whiteboard.ctx2 = this.gridCanvas.getContext("2d");
					}
				else
					{
						if ( this.$('#gridCanvas'+this.id).length < 1 ) { this.$('<canvas class="canvasGrid" id="gridCanvas'+this.id+'" width="1280" height="720"></canvas>').insertAfter('#sessionCanvas'+this.id); }
						
						this.gridCanvas = this.$Any('#gridCanvas'+this.id)[0];
						this.whiteboard.ctx2 = this.gridCanvas.getContext("2d");
					}
				
				this.gridColor = gridcolor ? gridcolor : this.strokeColor;
				this.drawBoard();
			}
		else
			{
				this.whiteboard.ctx2.clearRect(0, 0, this.canvas.width, this.canvas.height); //clear canvas
				
				if ( this.guestUser || this.hostVirtual ) 
					{  
						this.$('#gridCanvas').remove();
					}
				else
					{
						this.$('#gridCanvas'+this.id).remove();
					}
						
				this.gridCanvas = false;
				this.whiteboard.ctx2 = false;
			}
		
		if ( !this.guestUser && !this.hostVirtual && window['allPartDetails'][this.id] )
			{
				var canvasSize = {};
				canvasSize['w'] = this.canvas.width;
				canvasSize['h'] = this.canvas.height;
				
				this.whiteboard.splitRTMSend(window['allPartDetails'][this.id]['email'], 'draw'+this.sep+JSON.stringify(this.canvasLines)+'cSize'+JSON.stringify(canvasSize));
				if ( !window['highlightActive'] || ( window['highlightActive'] && window['highlightUserId'] == this.id ) ) { 
					console.log('gridSwith sendRTM 1');
				window['globalRTM'](window['allPartDetails'][this.id]['email'], 'grid'+this.sep+(this.gridOn ? 1 : 0 )+this.sep+this.gridColor); }
				
				if ( window['highlightActive'] && window['highlightUserId'] == this.id )
					{
						 this.$('.participantStreamPart').each(function(item, index){
						  let parIdMain = this.$(this).attr('id').split('participant_agora');
						  let parId = parseInt(parIdMain[1]);
						  if ( parId != window.currentUserData['id'] && parId != this.id )
							{
								console.log('gridSwith sendRTM 2');
								window['globalRTM'](window['allPartDetails'][parId]['email'], 'grid'+this.sep+(window['gridOn'+this.id] ? 1 : 0 )+this.sep+this.gridColor);
							}
						 });
					}
			}
	}
	
	canvasScreenshotClick() {
		this.whiteboard.drawImage();
	}
}

export default mouseActions;